import axios from 'axios';

export const loadMedia = (mediaId) => {
  const {
    REACT_APP_DATABASE_MEDIA,
  } = process.env;

  return axios
    .get(REACT_APP_DATABASE_MEDIA + mediaId, {})
    .then(({ data }) => ({
      id: data.id,
      src: data.source_url,
      alt: data.alt_text,
    }));
};
